import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StkTrfIndexActions, { StkTrfIndexTypes } from '../Stores/StkTrfIndex/Actions';

const getAppStore = state => state.app;

export function* stkTrfIndexFetchStkTrfIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(StkTrfIndexActions.stkTrfIndexFetchStkTrfIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkTrf/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        StkTrfIndexActions.stkTrfIndexFetchStkTrfIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkTrfIndexActions.stkTrfIndexFetchStkTrfIndexLoading(false));
  }
}

export function* stkTrfIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/stkTrfDetail/update/${hdrId}`));
}

export function* stkTrfIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/STK_TRF/${hdrId}/StkTrfHdr`));
}

export const saga = [
  takeLatest(StkTrfIndexTypes.STK_TRF_INDEX_FETCH_STK_TRF_INDEX, stkTrfIndexFetchStkTrfIndex),
  takeLatest(StkTrfIndexTypes.STK_TRF_INDEX_GO_TO_DOCUMENT, stkTrfIndexGoToDocument),
  takeLatest(StkTrfIndexTypes.STK_TRF_INDEX_GO_TO_AUDIT, stkTrfIndexGoToAudit)
];
